import { useParams } from '@tanstack/react-router'

export function useProjectId(): string | undefined {
  const { projectId } = useParams({ strict: false }) as { projectId?: string }
  return projectId
}
